import Modal from "Components/Modal/Modal";

export default Modal;
